import React from "react";
import "../styles/WorkFlow.css";
import { FaMicrochip, FaCloud, FaChartBar } from "react-icons/fa";

const WorkFlow = () => {
    return (
        <section id="workflow" className="workflow">
            <h2>Cara Kerja Sistem</h2>
            <div className="workflow-steps">
                <div className="step">
                    <FaMicrochip size={50} color="#007BFF" />
                    <h3>Sensor IoT</h3>
                    <p>Sensor mendeteksi volume air yang keluar dan jumlah galon yang terjual.</p>
                </div>
                <div className="step">
                    <FaCloud size={50} color="#28A745" />
                    <h3>Penyimpanan Cloud</h3>
                    <p>Data otomatis dikirim ke cloud dan bisa dipantau melalui aplikasi.</p>
                </div>
                <div className="step">
                    <FaChartBar size={50} color="#FF5733" />
                    <h3>Dashboard Aplikasi</h3>
                    <p>Pemilik usaha dapat melihat laporan penjualan, CCTV, dan GPS pengiriman.</p>
                </div>
            </div>
        </section>
    );
};

export default WorkFlow;
